import Big from '@web/walter-lib/big.js'

interface Props {
    showLockedBalance: boolean | undefined
    availableBalance: string | undefined
    unlockedBalance: string | undefined
    precision?: number
}

export const getAvailableBalance = ({ showLockedBalance, availableBalance, unlockedBalance, precision = 2 }: Props) => {
    const calculatedBalance = showLockedBalance ? new Big(unlockedBalance ?? '0') : new Big(availableBalance ?? '0')
    const isNegativeBalance = calculatedBalance.lt(0)

    //if string value is very low like 0.00000018 it might cause freeze because of big.js
    //toFixed will round it to precision and prevent freeze, but if it's negative it should return 0
    return isNegativeBalance ? '0' : calculatedBalance.toFixed(precision) ?? '0'
}
